import styled from "styled-components";
import { InviteIcon } from "@assets";
import { Button as AntButton, Modal as AntModal } from "antd";
import { BURMESE_LANGUAGE_CODE_LK } from "@constants";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 0 16px 0;
`;

export const ChainIcon = styled(InviteIcon)`
	@media screen and (max-width: 320px) {
		width: 50px;
		height: 50px;
	}
`;

export const InviteLinkTitle = styled.p`
	color: #5d5189;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	@media screen and (max-width: 425px) {
		font-size: 17px;
	}

	@media screen and (max-width: 375px) {
		font-size: 15px;
	}
`;

export const CreateLinkButton = styled(AntButton)`
	padding: 0;
	margin: 5px 0 0 0;
	width: ${(props) =>
		props.language === BURMESE_LANGUAGE_CODE_LK ? "200px" : "192px"};
	height: 55px;
	border-radius: 8px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;

	color: #ffffff !important;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	background: #49028e !important;

	:hover {
		background: #49028e !important;
		color: #ffffff !important;
	}

	/* svg {
		width: 40px !important;
		height: 40px !important;
	} */
`;

export const TermsAndConditionsContainer = styled.div`
	border-radius: 12px;
	padding: 16px 10px;
	margin: 16px 0 0 0;
`;

export const InviteLinkTerm = styled.p`
	text-align: center;
	color: #49028e;
	background-color: #f8eeff;
	border-radius: 8px;
	width: 80%;
	padding: 14px 12px;
	font-size: 16px;
	font-style: normal;
	line-height: 1.5;
	font-weight: 500;
	line-height: normal;
	margin: 0 auto;
	margin-bottom: 16px;
`;

export const InviteLinkTerms = styled.span`
	margin: 0px;
	padding: 0px;
	font-size: 12px;
	font-weight: 400;
	line-height: 24px;
	color: #9b92bb;
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
	color: #FFFFFF;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24.19px;
`;

export const CopyLink = styled.a`
	display: block;
	color: #ffffff;
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;

	:hover {
		color: #ffffff;
		text-decoration: underline;
	}
`;

export const CreateLinkWrapper = styled.div`
	margin-top: 30px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const ButtonWrapper = styled.div`
	background: #340067;
	display:flex;
	border-radius: 0 0 12px 12px;
	height: 59px;
	margin-bottom: 0 !important;
`;

export const ButtonDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50%;
	cursor: pointer;
	font-size: 16px;
	font-weight: 600;
`;

export const Modal = styled(AntModal)`
	.ant-modal-content {
		background: #49028E !important;
		border: none !important;
		padding: 0 !important;
		margin: 0 !important;
	}
	.ant-modal-body {
		padding: 0 !important;
	}
`;

export const TitleLinkWrapper = styled.div`
 padding: 16px 16px;
`;
